import React from 'react';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import { cardShape } from '@bibliocommons/bc-prop-types';

import './EventDateTime.scss';

export class EventDateTime extends React.PureComponent {
  formatDate(value) {
    return this.props.intl.formatDate(moment.utc(value).toDate(), {
      month: 'short',
      day: 'numeric'
    });
  }

  formatTime(value) {
    return this.props.intl.formatTime(moment.utc(value).toDate(), {
      hour: 'numeric',
      minute: 'numeric'
    });
  }

  renderDateTime() {
    const { card } = this.props;
    const event = card.get('event');

    // manual event date
    if (event.get('date')) {
      return event.get('date');
    }

    const startDate = this.formatDate(event.get('startTime'));
    const startTime = this.formatTime(event.get('startTime'));
    const endDate = this.formatDate(event.get('endTime'));
    const endTime = this.formatTime(event.get('endTime'));
    const isMultiDay = startDate !== endDate;
    const isAllDay = !startTime && !endTime;

    const eventDate = isMultiDay ? (
      <span>
        {startDate} &#8211; {endDate}
      </span>
    ) : (
      startDate
    );

    const eventTime = isAllDay ? (
      <FormattedMessage id="all_day" />
    ) : (
      <span>
        {startTime} &#8211; {endTime}
      </span>
    );

    return (
      <span>
        {eventDate} | {eventTime}
      </span>
    );
  }

  render() {
    if (this.props.card.get('event')) {
      return <div className="cp-event-date-time">{this.renderDateTime()}</div>;
    }

    return null;
  }
}

EventDateTime.propTypes = {
  card: cardShape.isRequired
};

export default injectIntl(EventDateTime);
